import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt", "title", "src", "preloader", "width", "height", "sources", "theme", "borderRadius", "display", "objectFit", "onLoad", "onError", "loading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { EImageSizeType } from '../../types';
import { clsx } from 'clsx';
import { Spinner } from '../../../loader';
import { getTheme } from '../../themes';
import { Error } from '../../internal/Error';
import { Picture } from '../../internal/Picture';
import styles from '../../styles/image.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var getImageSizeType = function getImageSizeType(el) {
  var width = el.getBoundingClientRect().width;
  if (width >= 320) {
    return EImageSizeType.L;
  }
  if (width < 40) {
    return EImageSizeType.NONE;
  }
  return EImageSizeType.S;
};
var ImageComponent = /*#__PURE__*/React.forwardRef(function Image(props, ref) {
  var alt = props.alt,
    title = props.title,
    src = props.src,
    _props$preloader = props.preloader,
    preloader = _props$preloader === void 0 ? true : _props$preloader,
    width = props.width,
    height = props.height,
    _props$sources = props.sources,
    sources = _props$sources === void 0 ? [] : _props$sources,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    _props$borderRadius = props.borderRadius,
    borderRadius = _props$borderRadius === void 0 ? '4px' : _props$borderRadius,
    display = props.display,
    objectFit = props.objectFit,
    onLoad = props.onLoad,
    onError = props.onError,
    loading = props.loading,
    rest = _objectWithoutProperties(props, _excluded);
  var imageEl = React.useRef(null);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    error = _React$useState4[0],
    setError = _React$useState4[1];
  var _React$useState5 = React.useState(EImageSizeType.NONE),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    imageSizeType = _React$useState6[0],
    setImageSizeType = _React$useState6[1];
  var fulfilled = !isLoading && !error;
  var themeClasses = getTheme(theme);
  var handleError = function handleError(e) {
    setIsLoading(false);
    setError(true);
    if (onError) {
      onError(e);
    }
  };
  var handleLoad = function handleLoad(e) {
    setIsLoading(false);
    if (onLoad) {
      onLoad(e);
    }
  };
  useIsomorphicLayoutEffect(function () {
    if (imageEl.current.complete) {
      setIsLoading(false);
      if (imageEl.current.naturalWidth === 0) {
        setError(true);
      }
    }
    setImageSizeType(getImageSizeType(imageEl.current));
  }, []);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: clsx(styles['container'], themeClasses['container']),
    style: {
      width: width,
      height: height,
      borderRadius: borderRadius,
      display: display
    },
    children: [!fulfilled && /*#__PURE__*/_jsx("div", {
      className: clsx(styles['layout'], themeClasses['layout'])
    }), isLoading && preloader && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['spinner'], themeClasses['spinner']),
      children: /*#__PURE__*/_jsx(Spinner, {
        color: "current_color",
        size: 16
      })
    }), error && !!imageSizeType && /*#__PURE__*/_jsx(Error, {
      size: imageSizeType,
      className: clsx(styles['error'], themeClasses['error'])
    }), /*#__PURE__*/_jsx(Picture, {
      className: clsx(styles['picture'], _defineProperty({}, styles['picture_visible'], fulfilled)),
      alt: alt,
      title: title,
      size: imageSizeType,
      objectFit: objectFit,
      onLoad: handleLoad,
      sources: sources,
      onError: handleError,
      src: src,
      ref: imageEl,
      loading: loading
    })]
  }));
});
ImageComponent.displayName = 'Image';

/**
 * Компонента изображения. <br />
 * Если в компонент предаеться список ссылкок, не забывайте последним элементом списка  <br />
 * передавать ссылку на картинку которая будет работать во всех браузерах.
 */
export var Image = /*#__PURE__*/React.memo(ImageComponent);